import Image from "next/image"

import GithubRepo from "./github-repo";
import Header from "./header";
import ProjectRow from "./project-row";

import cursorImg from '../../public/pngs/cursor.png';

export default function Modal(modalOptions = { "showModal": false, "mode": false }, modalHandler ) {

  var showModalClass = (modalOptions["showModal"]) ? "block" : "hidden";

  var heading = getHeading(modalOptions["mode"]);
  var logo = getLogo(modalOptions["mode"]);
  var body = getBody(modalOptions["mode"]);

  return (
    <div className={ "h-full w-full z-10 " + showModalClass } style={{ cursor: `url(${cursorImg.src}), auto` }}>
      <div className="am-bgfadein absolute top-0 w-full h-full bg-black opacity-40 z-5" onClick={ () => modalHandler(false) }>
      </div>

      <div className="am-fadein-modal transition w-[90%] lg:w-3/5 min-h-[25vh] absolute top-[1%] md:top-[17.5%] lg:top-[23.5%] left-[5%] lg:left-[20%] z-10">
        <div className="w-full min-h-[25vh] p-6 border bc-foreground bg-background">
          <div className="w-full flex flex-row z-5">
            <Header
              text={ heading }>
            </Header>
            <div className="relative ml-auto font-bold text-4xl mx-1 cl-foreground">
              <a onClick={ () => modalHandler(false) } className="absolute -top-2 right-1 cursor-pointer">
                x
              </a>
            </div>
          </div>

          <div className="pointer-events-none opacity-10 w-[20rem] h-[20rem] top-0 left-[-19rem] absolute z-0">
            { logo && window.innerWidth > 768 &&
              <Image
                fill={true}
                className="w-full h-full skill-filter"
                src={ logo } 
                alt="GitHub Repo Link">
              </Image>
            }
          </div>

          <div className="text-white text-2xl mt-6 z-5">
            { body }
          </div>
        </div>
      </div>
    </div>
  );


  function getHeading(mode) {
    switch(mode) {
      case "php": return "PHP";
      case "javascript": return "JavaScript";
      case "dart": return "Dart";
      case "csharp": return "C#";
      case "python": return "Python";
      case "java": return "Java";
      case "vb": return "Visual Basic";

      case "wordpress": return "WordPress";
      case "zendframework": return "Zend Framework 3 / Laminas";
      case "flutter": return "Flutter";
      case "nextjs": return "Next.js";
      case "dotnet": return ".Net";
      case "godotengine": return "Godot Engine";
      case "spring": return "Spring Framework";

      case "mysql": return "MySQL";
      case "reactjs": return "React";
      case "tailwind": return "Tailwind";
      case "git": return "Git";
      case "github": return "GitHub";
      case "gitlab": return "GitLab";
      case "nodejs": return "Node.js";
      case "wamp": return "WAMP";
      case "intellijidea": return "Intellij Idea";
      case "visualstudiocode": return "Visual Studio Code";
      case "visualstudio": return "Visual Studio";
      case "putty": return "PuTTY";
      case "winscp": return "WinSCP";

      case "upwn": return "Upwn";
      case "idwal": return "Idwal";
      case "unicalc": return "UniCalc";
      case "robot.ai": return "Robot.AI";
      case "activito": return "Activito";

      case "languages": return "Languages";
      case "frameworks": return "Frameworks";
      case "tools": return "Tools";

      default: return "No Heading Found!";
    }
  }

  function getLogo(mode) {
    switch(mode) {
      case "php": return "svgs/php.svg";
      case "javascript": return "svgs/javascript.svg";
      case "dart": return "svgs/dart.svg";
      case "csharp": return "svgs/csharp.svg";
      case "python": return "svgs/python.svg";
      case "java": return "svgs/java.svg";
      case "vb": return "svgs/vb.svg";

      case "wordpress": return "svgs/wordpress.svg";
      case "zendframework": return "svgs/zendframework.svg";
      case "flutter": return "svgs/flutter.svg";
      case "nextjs": return "svgs/nextjs.svg";
      case "dotnet": return "svgs/dotnet.svg";
      case "godotengine": return "svgs/godotengine.svg";
      case "spring": return "svgs/spring.svg";

      case "mysql": return "svgs/mysql.svg";
      case "reactjs": return "svgs/reactjs.svg";
      case "tailwind": return "svgs/tailwind.svg";
      case "git": return "svgs/git.svg";
      case "github": return "svgs/github.svg";
      case "gitlab": return "svgs/gitlab.svg";
      case "nodejs": return "svgs/nodejs.svg";
      case "wamp": return "svgs/wamp.svg";
      case "intellijidea": return "svgs/intellijidea.svg";
      case "visualstudiocode": return "svgs/visualstudiocode.svg";
      case "visualstudio": return "svgs/visualstudio.svg";
      case "putty": return "svgs/putty.svg";
      case "winscp": return "svgs/winscp.svg";

      default: return false;
    }
  }


  function getBody(mode) {

    const linkProps = {
      className: "underline font-bold cl-foreground",
      target: "_blank",
      rel: "noopener noreferrer"
    };

    const renderSection = (content, mt = 4) => (
      <div className={ `mt-${mt}` }>{content}</div>
    );

    const renderSubSection = (title, content = false, mt = 4) => (
      <div className={ `mt-${mt} ml-4` }>
        { (content) ? '' : '- '  } <span className="font-bold">{title}</span> { (content) ?  ' - ' : '' } { content }
      </div>
    );

    const wsp = () => (
      <>{ " " }</>
    );

    switch (mode) {

      /**
       * LANGUAGES
       */
      case "php":
        return (
          <div>
            { renderSection(
              <>
                PHP is the programming language I have the most professional experience with.
              </>
            ) }
            { renderSection(
              <>
                Over the course of my time at { wsp() }
                <a {...linkProps} href="https://www.merisis.com">
                  Merisis Technology Ltd.
                </a>
                , I have used PHP to create a wide-range of web-applications, ranging from
                enterprise-level internal software to small-scale booking sites for local
                businesses.
              </>
            ) }
            { renderSection(
              <>
                The frameworks I have primarily utilised using PHP (as shown on the Skills
                page) are:
                { renderSubSection(
                  <>
                    Zend 3 / Laminas
                  </>,
                  <>
                    I have used Zend 3 / Laminas for large-scale, enterprise-level web-applications that require complex 
                    server-side processing.
                  </>
                ) }
                { renderSubSection(
                  <>
                    WordPress
                  </>,
                  <>
                    I have used WordPress for public-facing sites where clients want the ability to modify the site's contents 
                    akin to a CMS.
                  </>
                ) }
              </>,
              12
            ) }
            { renderSection(
              <>
                I have worked on projects using PHP versions 5.6, 7.2, 7.4, 8.0 and 8.1.
              </>,
              12
            ) }
            { renderSection(
              <>
                I have utilised Composer to manage dependencies across nearly all PHP projects I have worked on.
              </>
            ) }
            { renderSection(
              <div className="italic">
                Using PHP, I have both led projects and worked within a team to produce high-quality solutions.
              </div>,
              12
            ) }
            { renderSection(
              <div className="italic">
                Using PHP, I have both created new applications from scratch and worked on developments/helpdesks for pre-existing codebases.
              </div>
            ) }
          </div>
        );

      case "javascript":
        return (
          <div>
            { renderSection(
              <>
                JavaScript is one of the programming languages I am most familiar with.
              </>
            ) }
            { renderSection(
              <>
                I have used it in personal projects, during my degree and in a professional
                capacity at { wsp() }
                <a {...linkProps} href="https://www.merisis.com">
                  Merisis Technology Ltd.
                </a> { wsp() }
                to produce web-applications ranging from enterprise-level internal software to 
                small-scale booking sites for local businesses.
              </>
            ) }
            { renderSection(
              <>
                I have used JavaScript for both back-end and front-end development over many
                projects and technology stacks:
                { renderSubSection(
                  <>
                    Front-End
                  </>,
                  <>
                    I have used JavaScript for front-end, client-side scripting for WordPress, Zend/Laminas, Spring Boot, pure 
                    HTML/CSS/JS sites & Flask applications.
                  </>
                ) }
                { renderSubSection(
                  <>
                    Back-End
                  </>,
                  <>
                    I have used JavaScript for back-end development for WordPress (Blocks/FSE), Next.js & React Native 
                    applications.
                  </>
                ) }
              </>,
              12
            ) }
            { renderSection(
              <>
                I have utilised { wsp() }
                <a {...linkProps} href="https://www.npmjs.com">
                  NPM
                </a> { wsp() }
                  and { wsp() }
                <a {...linkProps} href="https://yarnpkg.com">
                  Yarn
                </a> { wsp() }
                to manage packages in the majority of JavaScript projects I have worked on. I have used
                these package managers in conjunction with { wsp() }
                <a {...linkProps} href="https://github.com/nodists/nodist">
                  Nodist
                </a> { wsp() }
                and { wsp() }
                <a {...linkProps} href="https://volta.sh/">
                  Volta
                </a> { wsp() }
                for version management across multiple projects.
              </>,
              12
            ) }
            { renderSection(
              <div className="italic">
                Using JavaScript, I have both led projects and worked within a team to produce high-quality solutions.
              </div>,
              12
            ) }
            { renderSection(
              <div className="italic">
                Using JavaScript, I have both created new applications from scratch and worked on developments/helpdesks for 
                pre-existing codebases.
              </div>
            ) }
          </div>
        );

      case "dart":
        return (
          <div>
            { renderSection(
              <>
                Dart is my go-to language for mobile app development (in conjunction with
                Flutter).
              </>
            ) }
            { renderSection(
              <>
                I have used it at { wsp() }
                <a {...linkProps} href="https://www.merisis.com">
                  Merisis Technology Ltd.
                </a> { wsp() }
                in a professional capacity, during a short-term contract for { wsp() }
                <a {...linkProps} href="https://www.idwalmarine.com">
                  Idwal
                </a> { wsp() }
                provided by Cardiff University and during my degree in Applied Software
                Engineering at Cardiff University.
              </>
            )}
            { renderSection(
              <>
                I've used Dart for both front-end design/scaffolding and back-end development.
              </>
            ) }
            { renderSection(
              <>
                I've developed multiple personal projects using Flutter available both on the
                "Projects" page of this site and my { wsp() }
                <a {...linkProps} href="https://github.com/mattdbarnett">
                  GitHub profile
                </a>
                .
              </>,
              12
            ) }
            { renderSection(
              <>
                The repository for the mobile application I developed within a team for { wsp() }
                <a {...linkProps} href="https://www.idwalmarine.com">
                  Idwal
                </a> { wsp() }
                is also { wsp() }
                <a {...linkProps} href="https://github.com/mattdbarnett/shipping-inspection-app">
                  publicly available and open source
                </a>
                .
              </>
            ) }
            { renderSection(
              <div className="italic">
                Using Dart, I have worked within a team to produce high-quality solutions for mobile applications.
              </div>,
              12
            ) }
            { renderSection(
              <div className="italic">
                Using Dart, I have both created new applications from scratch and worked on developments/helpdesks for 
                pre-existing codebases.
              </div>
            ) }
          </div>
        );

      case "csharp":
        return (
          <div>
            { renderSection(
              <>
                C# is the language I have used most commonly across my personal projects.
              </>
            ) }
            { renderSection(
              <>
                The frameworks I have primarily utilised using C# are:
                { renderSubSection(
                  <>
                    .Net
                  </>,
                  <>
                    I have used .Net for personal WinForms projects - primarily my project { wsp() }
                    "<a {...linkProps} href="https://github.com/mattdbarnett/unicalc">
                      UniCalc
                    </a>" { wsp() }
                    for compiling university module scores.
                  </>
                ) }
                { renderSubSection(
                  <>
                    Godot Engine (Mono Version)
                  </>,
                  <>
                    I have used Godot Engine for multiple projects including my final project during my degree, games I have 
                    developed individually and simulations I have developed for fun.
                  </>
                ) }
              </>,
              12
            )}
          </div>
        );

      case "python":
        return (
          <div>
            { renderSection(
              <>
                Python is one of the first languages I learnt and the predominant language I worked with during the first year 
                of my degree.
              </>
            ) }
            { renderSection(
              <>
                During my degree I used Python to make both command-line applications and web-applications using Flask.
              </>
            ) }
            { renderSection(
              <>
                I've also introduced multiple family and friends to programming through basic lessons using Python in VS Code.
              </>
            ) }
          </div>
        );

      case "java":
        return (
          <div>
            { renderSection(
              <>
                Java was the primary language I used throughout the second & third years of
                my degree. I've had experience using it since 2014 where I took a { wsp() }
                <a {...linkProps} href="/java-course">
                  course from the University of Reading in Mobile Game Development with Java
                </a>
                .
              </>
            ) }
            { renderSection(
              <>
                During my degree I learnt & used the Java framework Spring Boot to produce web-applications and REST services.
              </>
            ) }
            { renderSection(
              <>
                I used Java with Spring Boot during my Second Year Group Project for a { wsp() } 
                <a {...linkProps} href="https://github.com/mattdbarnett/cu-staff-reflection-webapp">
                  reflective web-application for Cardiff University staff
                </a>.
              </>
            ) }
          </div>
        );

      case "vb":
        return (
          <div>
            { renderSection(
              <>
               I learnt Visual Basic throughout my Computer Science GCSE & Computer Science A-Level. I predominantly used it in 
               .Net to create WinForms projects.
              </>
            ) }
            { renderSection(
              <>
                I used Visual Basic during my Year 13 A-Level project, where I created a basic text-based version of the popular 
                game 'Sims'.
              </>
            ) }
          </div>
        );

      /**
       * FRAMEWORKS
       */
      case "wordpress":
        return (
          <div>
            { renderSection(
              <>
                I have indepth professional knowledge using WordPress through my experience working at { wsp() }
                <a {...linkProps} href="https://www.merisis.com">
                  Merisis Technology Ltd.
                </a>, { wsp() }
                where I developed WordPress themes and projects for a multitude of clients.
              </>
            ) }
            { renderSection(
              <>
                I have experience developing WordPress themes in { wsp() }
                <a {...linkProps} href="https://learn.wordpress.org/lesson/introduction-to-classic-themes/">
                  Classic
                </a>, { wsp() }
                <a {...linkProps} href="https://developer.wordpress.org/news/2024/12/bridging-the-gap-hybrid-themes/">
                  Hybrid
                </a>, { wsp() } and { wsp() }
                <a {...linkProps} href="https://fullsiteediting.com/">
                  FSE
                </a> { wsp() }
                methodologies. By utilising the range of WordPress development patterns, I have professional 
                experience using PHP, Composer, React, JavaScript, Node.js, NPM/Yarn, SASS, PostCSS, Webpack, Volta and 
                Roots in conjunction with WordPress to provide the best possible web-applications for clients.
              </>
            ) }
            { renderSection(
              <>
                Regarding project structure and conventions, I am familiar with both the standard WordPress 
                project structure and Root's { wsp() }
                <a {...linkProps} href="https://roots.io/bedrock/">
                  Bedrock 
                </a> { wsp() }
                structure.
              </>
            ) }
            { renderSection(
              <>
                In many WordPress projects I have utilised plugins either from pre-existing
                developments or to give clients futher customisability (akin to a CMS). 
                These plugins include { wsp() }
                <a {...linkProps} href="https://www.advancedcustomfields.com">
                  ACF 
                </a>, { wsp() }
                <a {...linkProps} href="https://metabox.io">
                  MetaBox 
                </a>, { wsp() }
                <a {...linkProps} href="https://sitekit.withgoogle.com">
                  Google SiteKit
                </a>, { wsp() }
                <a {...linkProps} href="https://www.monsterinsights.com">
                  MonsterInsights 
                </a>, { wsp() }
                <a {...linkProps} href="https://www.wordfence.com/">
                  WordFence 
                </a>, { wsp() }
                <a {...linkProps} href="https://woocommerce.com">
                  WooCommerce 
                </a>, { wsp() }
                <a {...linkProps} href="https://complianz.io">
                  Complianz 
                </a>, { wsp() }
                <a {...linkProps} href="https://en-gb.wordpress.org/plugins/mappress-google-maps-for-wordpress">
                  MapPress 
                </a>, { wsp() }
                <a {...linkProps} href="https://publishpress.com">
                  PublishPress 
                </a>{ wsp() } and { wsp() }
                <a {...linkProps} href="https://wpmailsmtp.com">
                  WP Mail SMTP. 
                </a>, { wsp() }
              </>,
              12
            ) }
            { renderSection(
              <div className="italic">
                Using WordPress, I have both led projects and worked within a team to produce 
                high-quality solutions.
              </div>,
              12
            ) }
            { renderSection(
              <div className="italic">
                Using WordPress, I have both created new applications from scratch and worked on 
                developments/helpdesks for pre-existing codebases.
              </div>
            ) }
          </div>
        );

      case "zendframework":
        return (
          <div>
            { renderSection(
              <>
                I have strong professional experience using Zend Framework 3 / Laminas.
              </>
            ) }
            { renderSection(
              <>
                While at { wsp() }
                <a {...linkProps} href="https://www.merisis.com">
                  Merisis Technology Ltd.
                </a> { wsp() }
                I have used ZF3/Laminas to develop commercial-grade web-applications for multiple 
                clients.
              </>
            )}
            { renderSection(
              <>
                I have indepth knowledge at creating and routing Controllers, Services, Factories &
                Tables and using them to implement efficient & complex processes.
              </>
            )}
            { renderSection(
              <div className="italic">
                Using ZF3/Laminas, I have both led projects and worked within a team to produce 
                high-quality solutions.
              </div>,
              12
            ) }
            { renderSection(
              <div className="italic">
                Using ZF3/Laminas, I have both created new applications from scratch and worked on 
                developments/helpdesks for pre-existing codebases.
              </div>
            ) }
          </div>
        );

      case "flutter":
        return (
          <div>
            { renderSection(
              <>
                Flutter is my go-to framework for mobile app development.
              </>
            ) }
            { renderSection(
              <>
                I have used Flutter at { wsp() }
                <a {...linkProps} href="https://www.merisis.com">
                  Merisis Technology Ltd.
                </a> { wsp() }
                in a professional capacity, during a short-term contract for { wsp() }
                <a {...linkProps} href="https://www.idwalmarine.com">
                  Idwal
                </a> { wsp() }
                provided by Cardiff University and during my degree in Applied Software
                Engineering at Cardiff University.
                </>
            )}
            { renderSection(
              <>
                I've developed multiple personal projects using Flutter available both on the
                "Projects" page of this site and my { wsp() }
                <a {...linkProps} href="https://github.com/mattdbarnett">
                  GitHub profile
                </a>
                .
              </>,
              12
            ) }
            { renderSection(
              <>
                The repository for the mobile application I developed within a team for { wsp() }
                <a {...linkProps} href="https://www.idwalmarine.com">
                  Idwal
                </a> { wsp() }
                is also { wsp() }
                <a {...linkProps} href="https://github.com/mattdbarnett/shipping-inspection-app">
                  publicly available and open source
                </a>
                .
              </>
            ) }
            { renderSection(
              <div className="italic">
                Using Flutter, I have worked within a team to produce high-quality solutions for 
                mobile applications.
              </div>,
              12
            ) }
            { renderSection(
              <div className="italic">
                Using Flutter, I have both created new applications from scratch and worked on 
                developments/helpdesks for pre-existing codebases.
              </div>
            ) }
          </div>
        );
      
      case "nextjs":
        return (
          <div>
            { renderSection(
              <>
                Next.js is my go-to framework for designing front-end interfaces and creating static 
                websites (such as this one).
              </>
            ) }
            { renderSection(
              <>
                I have used Next.js in a professional capacity while at { wsp() }
                <a {...linkProps} href="https://www.merisis.com">
                  Merisis Technology Ltd.
                </a> { wsp() }
                to produce multiple front-end designs for clients for them to choose from
                before proceeding to dynamic implementation (either with WordPress for CMS 
                features or   ZF3/Laminas for more complex server-side processing).
              </>
            ) }
            { renderSection(
              <>
                Using Next.js for the designing process has been incredibly useful, especially 
                thanks to the speed of setting up a project using Next.js and the fast
                refresh feature, allowing me to create designs for clients quickly
                and effectively.
              </>
            ) }
            { renderSection(
              <>
                I created this portfolio site using Next.js!
              </>
            ) }
            { renderSection(
              <div className="italic">
                Using Next.js, I have produced high-quality front-end designs from scratch and 
                worked on developments/helpdesks for pre-existing codebases.
              </div>,
              12
            ) }
          </div>
        );

      case "dotnet":
        return (
          <div>
            { renderSection(
              <>
                .Net is my go-to framework for developing Windows applications 
                - typically using WinForms. 
              </>
            ) }
            { renderSection(
              <>
                I learnt the legacy .NET Framework during my Computer Science A-Level where I
                produced WinForms applications using VB. 
              </>
            )}
            { renderSection(
              <>
                Since then, I have used .NET 6.0 with C# to create a Windows desktop application 
                for predicting and calculating statistics for prospective UK university graduates 
                called { wsp() }
                "<a {...linkProps} href="https://github.com/mattdbarnett/unicalc">
                  UniCalc
                </a>" { wsp() } 
                - which is available on the "Projects" page of this site.
              </>
            )}
          </div>
        );

      case "godotengine":
        return (
          <div>
            { renderSection(
              <>
                Godot Engine is my go-to framework for Game Development.
              </>
            ) }
            { renderSection(
              <>
                I learnt Godot Engine in my free time while at College & University.
              </>
            ) }
            { renderSection(
              <>
                I was able to apply my knowledge during my third year at Cardiff University,
                where for my third year project I created a { wsp() } 
                <a {...linkProps} href="https://github.com/mattdbarnett/infinite-colour-runner-game">
                  procedurally generated infinite runner video game
                </a> { wsp() } 
                using Godot engine and GDScript.
              </>,
              12
            ) }
            { renderSection(
              <>
                Since then I have used Godot Mono (the official C# fork of Godot Engine) to
                create a simulation where { wsp() } 
                <a {...linkProps} href="https://github.com/mattdbarnett/robot-ai-simulation">
                  robots compete to survive and preproduce
                </a>.
              </>
            ) }
            { renderSection(
              <div className="italic">
                Using Godot Engine, I have created high-quality game applications 
                from scratch.
              </div>,
              12
            ) }
          </div>
        );
      
      case "spring":
        return (
          <div>
            { renderSection(
              <>
                I learnt Spring & Spring Boot during the second year of my degree at Cardiff University.
              </>
            ) }
            { renderSection(
              <>
                I used Spring Boot it during my Second Year Group Project for a { wsp() } 
                <a {...linkProps} href="https://github.com/mattdbarnett/cu-staff-reflection-webapp">
                  reflective web-application for Cardiff University staff
                </a>.
              </>
            ) }
            { renderSection(
              <>
                While learning & developing with Spring, I used a CI/CD Pipeline using Checkstyle to always adhere to best
                Java/Spring practices.
              </>
            ) }
          </div>
        );


      /**
       * TOOLS
       */
      case "mysql":
        return (
          <div>
            { renderSection(
              <>
                I have strong professional experience using MySQL across a variety of projects.
              </>
            ) }
            { renderSection(
              <>
                I have used MySQL and MySQL Server for database management across the majority 
                of projects I have worked on in a professional capacity.
              </>
            ) }
            { renderSection(
              <>
                I have accessed and modified MySQL (and MariaDB) databases and their structures
                using MySQL Workbench & HeidiSQL.
              </>
            ) }
            { renderSection(
              <>
                I have developed MySQL (and MariaDB) databases using both WAMP and LAMP technology
                stacks.
              </>
            ) }
            { renderSection(
              <div className="italic">
                Using MySQL, I have created complex queries for databases in projects I have led 
                and projects where I have worked within a team.
              </div>,
              12
            ) }
            { renderSection(
              <div className="italic">
                Using MySQL, I have both created new large scale relational-databases from scratch and 
                worked on developments/helpdesks for pre-existing database structures.
              </div>
            ) }
          </div>
        );

      case "reactjs":
        return (
          <div>
            { renderSection(
              <>
                I have used React.js to build responsive interfaces and components across multiple projects.
              </>
            ) }
            { renderSection(
              <>
                The frameworks I have developed with, that utilise React, are:
                { renderSubSection(
                  <>
                    WordPress (Hybrid/FSE)
                  </>,
                  <>
                    I have used React in WordPress to create dynamic, customisable blocks for clients to
                    build their web pages with.
                  </>
                ) }
                { renderSubSection(
                  <>
                    Next.js
                  </>,
                  <>
                    I have used React in Next.js to build designs and static websites for clients. This
                    site itself was built using Next.js and React.
                  </>
                ) }
              </>,
              12
            ) }
            { renderSection(
              <div className="italic">
                Using React.js (with a compatible framework), I have both led projects and worked within 
                a team to produce high-quality solutions.
              </div>,
              12
            ) }
            { renderSection(
              <div className="italic">
                Using React.js (with a compatible framework), I have both created new applications from 
                scratch and worked on developments/helpdesks for 
                pre-existing codebases.
              </div>
            ) }
          </div>
        );
      case "tailwind":
        return (
          <div>
            { renderSection(
              <>
                I have strong professional knowledge using Tailwind to style web-applications.
              </>
            ) }
            { renderSection(
              <>
                I have used Tailwind in Classic, Hybrid and FSE WordPress sites to create appealing visual
                solutions for many clients. I have also utilised it extensively with Next.js for designs
                and sites with static content.
              </>
            ) }
            { renderSection(
              <div className="italic">
                Using Tailwind, I have both created new front-end designs from 
                scratch and kept styling consistent & uniform while working
                on pre-existing codebases.
              </div>,
              12
            ) }
          </div>
        );

      case "git":
        return (
          <div>
            { renderSection(
              <>
                I have indepth knowledge of using Git both personally and professionally.
              </>
            ) }
            { renderSection(
              <>
                Professionally, while at { wsp() }
                <a {...linkProps} href="https://www.merisis.com">
                  Merisis Technology Ltd.
                </a> { wsp() }
                I have used Git as the primary version control across all the projects I
                have worked on. This includes initalising repositories, committing,
                branching, rebasing and merging (and occasionally, reverting).
              </>
            ) }
            { renderSection(
              <>
                Personally, I have undertaken many of the same actions as listed above. This
                is made shown in my { wsp() }
                <a {...linkProps} href="https://github.com/mattdbarnett">
                  GitHub profile
                </a> { wsp() }
                which lists most of my personal projects and their respective Git histories.
              </>
            ) }
            { renderSection(
              <div className="italic">
                Using Git as the primary version control, I have both led projects and worked 
                within a team to produce high-quality solutions.
              </div>,
              12
            ) }
          </div>
        );

      case "github":
        return (
          <div>
            { renderSection(
              <>
                I have indepth knowledge of using GitHub.
              </>
            ) }
            { renderSection(
              <>
                For all of the personal projects I have produced, I used GitHub as my primary
                Git-platform for storing and sharing code.
              </>
            ) }
            { renderSection(
              <>
                I have also used GitHub professionally when certain clients have had strict
                policies regarding managing their repositories themselves, requiring me to
                join their "GitHub Organisations".
              </>
            ) }
          </div>
        );

      case "gitlab":
        return (
          <div>
            { renderSection(
              <>
                I have professional experience using GitLab.
              </>
            ) }
            { renderSection(
              <>
                Both at Cardiff Univeristy and { wsp() }
                <a {...linkProps} href="https://www.merisis.com">
                  Merisis Technology Ltd.
                </a>, { wsp() }
                it was the primary source control client, in part
                due to their ability to host GitLab independently of
                any external organisation.
              </>
            ) }
            { renderSection(
              <>
                I have used GitLab for merges, branch comparisons, Agile
                scrums/stand-ups, issue management, weighting and project
                management.
              </>
            ) }
          </div>
        );

      case "nodejs":
        return (
          <div>
            { renderSection(
              <>
                I have professional experience using Node.js for server-side web development.
              </>
            ) }
            { renderSection(
              <>
                I have used Node.js in conjunction with { wsp() }
                <a {...linkProps} href="https://www.npmjs.com">
                  NPM
                </a> { wsp() }
                  and { wsp() }
                <a {...linkProps} href="https://yarnpkg.com">
                  Yarn
                </a> { wsp() }
                to integrate packages and build scalable web-applications in JavaScript.
              </>
            ) }
            { renderSection(
              <>
                To manage Node.js versions across multiple projects and clientele, I have used { wsp() }
                <a {...linkProps} href="https://github.com/nodists/nodist">
                  Nodist
                </a> { wsp() }
                and { wsp() }
                <a {...linkProps} href="https://volta.sh/">
                  Volta
                </a>.
              </>
            ) }
          </div>
        );

      case "wamp":
        return (
          <div>
            { renderSection(
              <>
                I have professional experience using WAMP to locally host and develop ZF3/Laminas,
                WordPress and pure HTML/CSS/JS web applications locally.
              </>
            ) }
            { renderSection(
              <>
                I have used WAMP to switch between PHP, Apache and MySQL versions for a range
                of projects and clientele.
              </>
            ) }
          </div>
        );

      case "intellijidea":
        return (
          <div>
            { renderSection(
              <>
                I have used IntelliJ Idea to produce Java/Spring web-applications, Android
                mobile applications and Flutter mobile applications.
              </>
            ) }
            { renderSection(
              <>
                I first utilised IntelliJ Idea during the second year of my degree in
                Applied Software Engineering as my primary IDE for Java development.
              </>
            ) }
            { renderSection(
              <>
                The majority of my experience in IntelliJ Idea comes from one of its most
                popular forks - { wsp() }
                <a {...linkProps} href="https://developer.android.com/studio">
                  Android Studio
                </a>. This is my primary IDE for Flutter development, due to the integrated
                development tools it provides.
              </>
            ) }
          </div>
        );

      case "visualstudiocode":
        return (
          <div>
            { renderSection(
              <>
                Visual Studio Code is my primary code editor, and the one I have the most
                experience using both professionally and personally.
              </>
            ) }
            { renderSection(
              <>
                I have used VS Code to program and debug in PHP, JavaScript, Dart, Python, C#, 
                GDScript and Go.
              </>
            ) }
          </div>
        );

      case "visualstudio":
        return (
          <div>
            { renderSection(
              <>
                Visual Studio has been my primary IDE in producing applications with .Net,
                C# and VB.
              </>
            ) }
            { renderSection(
              <>
                I first learnt Visual Studio during my Computer Science A-Level,
                then utilised it further both during my Applied Software Engineering
                degree at Cardiff University and personally when developing my personal
                project { wsp() }
                "<a {...linkProps} href="https://github.com/mattdbarnett/unicalc">
                  UniCalc
                </a>".
              </>
            ) }
          </div>
        );

      case "putty":
        return (
          <div>
            { renderSection(
              <>
                I have used PuTTy professionally as my primary client for SSH.
              </>
            ) }
            { renderSection(
              <>
                I have utilised PuTTy to initialise, manage and update web applications in
                Dev, UAT and Live environments.
              </>
            ) }
            { renderSection(
              <>
                My experience using PuTTy ranges from updating applications via Git,
                modifying environment files and setting up Apache configurations for
                new web applications.
              </>
            ) }
          </div>
        );

      case "winscp":
        return (
          <div>
            { renderSection(
              <>
                I have used WinSCP professionally as my primary client for FTP and SFTP.
              </>
            ) }
            { renderSection(
              <>
                I have utilised WinSCP to manage and update web applications in
                Dev, UAT and Live environments.
              </>
            ) }
            { renderSection(
              <>
                My experience using WinSCP ranges from migrating large untracked files
                between environments, backing up data and downloading older repositories without
                version control to investigate client-reported issues.
              </>
            ) }
            { renderSection(
              <>
                ( I have also utilised FileZilla when it has been required. )
              </>
            ) }
          </div>
        );

      /**
       * Headings
       */
      case "languages":
        return (
          <div>
            { renderSection(
                <>
                  The languages listed are:
                  { renderSubSection(
                    <a className="cursor-pointer underline font-bold cl-foreground" 
                      onClick={ () => modalHandler({ "showModal": true, "mode": "php" }) }>
                      PHP
                    </a>
                  ) }
                  { renderSubSection(
                    <a className="cursor-pointer underline font-bold cl-foreground" 
                      onClick={ () => modalHandler({ "showModal": true, "mode": "javascript" }) }>
                      JavaScript
                    </a>,
                  ) }
                  { renderSubSection(
                    <a className="cursor-pointer underline font-bold cl-foreground" 
                      onClick={ () => modalHandler({ "showModal": true, "mode": "dart" }) }>
                      Dart
                    </a>,
                  ) }
                  { renderSubSection(
                    <a className="cursor-pointer underline font-bold cl-foreground" 
                      onClick={ () => modalHandler({ "showModal": true, "mode": "csharp" }) }>
                      C# (C Sharp)
                    </a>,
                  ) }
                  { renderSubSection(
                    <a className="cursor-pointer underline font-bold cl-foreground" 
                      onClick={ () => modalHandler({ "showModal": true, "mode": "python" }) }>
                      Python
                    </a>,
                  ) }
                  { renderSubSection(
                    <a className="cursor-pointer underline font-bold cl-foreground" 
                      onClick={ () => modalHandler({ "showModal": true, "mode": "java" }) }>
                      Java
                    </a>,
                  ) }
                  { renderSubSection(
                    <a className="cursor-pointer underline font-bold cl-foreground" 
                      onClick={ () => modalHandler({ "showModal": true, "mode": "vb" }) }>
                      Visual Basic
                    </a>,
                  ) }
                </>
            ) }
          </div>
        );

      case "frameworks":
        return (
          <div>
            { renderSection(
                <>
                  The frameworks listed are:
                  { renderSubSection(
                    <a className="cursor-pointer underline font-bold cl-foreground" 
                      onClick={ () => modalHandler({ "showModal": true, "mode": "wordpress" }) }>
                      WordPress
                    </a>
                  ) }
                  { renderSubSection(
                    <a className="cursor-pointer underline font-bold cl-foreground" 
                      onClick={ () => modalHandler({ "showModal": true, "mode": "zendframework" }) }>
                      Zend Framework 3 / Laminas
                    </a>,
                  ) }
                  { renderSubSection(
                    <a className="cursor-pointer underline font-bold cl-foreground" 
                      onClick={ () => modalHandler({ "showModal": true, "mode": "flutter" }) }>
                      Flutter
                    </a>,
                  ) }
                  { renderSubSection(
                    <a className="cursor-pointer underline font-bold cl-foreground" 
                      onClick={ () => modalHandler({ "showModal": true, "mode": "nextjs" }) }>
                      Next.js
                    </a>,
                  ) }
                  { renderSubSection(
                    <a className="cursor-pointer underline font-bold cl-foreground" 
                      onClick={ () => modalHandler({ "showModal": true, "mode": "dotnet" }) }>
                      .Net
                    </a>,
                  ) }
                  { renderSubSection(
                    <a className="cursor-pointer underline font-bold cl-foreground" 
                      onClick={ () => modalHandler({ "showModal": true, "mode": "godotengine" }) }>
                      Godot Engine
                    </a>,
                  ) }
                  { renderSubSection(
                    <a className="cursor-pointer underline font-bold cl-foreground" 
                      onClick={ () => modalHandler({ "showModal": true, "mode": "spring" }) }>
                      Spring Framework
                    </a>,
                  ) }
                </>
            ) }
          </div>
        );

      case "tools":
        return (
          <div>
            { renderSection(
                <>
                  The tools listed are:
                  { renderSubSection(
                    <a className="cursor-pointer underline font-bold cl-foreground" 
                      onClick={ () => modalHandler({ "showModal": true, "mode": "mysql" }) }>
                      MySQL
                    </a>
                  ) }
                  { renderSubSection(
                    <a className="cursor-pointer underline font-bold cl-foreground" 
                      onClick={ () => modalHandler({ "showModal": true, "mode": "reactjs" }) }>
                      React
                    </a>,
                  ) }
                  { renderSubSection(
                    <a className="cursor-pointer underline font-bold cl-foreground" 
                      onClick={ () => modalHandler({ "showModal": true, "mode": "tailwind" }) }>
                      Tailwind
                    </a>,
                  ) }
                  { renderSubSection(
                    <a className="cursor-pointer underline font-bold cl-foreground" 
                      onClick={ () => modalHandler({ "showModal": true, "mode": "git" }) }>
                      Git
                    </a>,
                  ) }
                  { renderSubSection(
                    <a className="cursor-pointer underline font-bold cl-foreground" 
                      onClick={ () => modalHandler({ "showModal": true, "mode": "github" }) }>
                      GitHub
                    </a>,
                  ) }
                  { renderSubSection(
                    <a className="cursor-pointer underline font-bold cl-foreground" 
                      onClick={ () => modalHandler({ "showModal": true, "mode": "gitlab" }) }>
                      GitLab
                    </a>,
                  ) }
                  { renderSubSection(
                    <a className="cursor-pointer underline font-bold cl-foreground" 
                      onClick={ () => modalHandler({ "showModal": true, "mode": "nodejs" }) }>
                      Node.js
                    </a>,
                  ) }
                  { renderSubSection(
                    <a className="cursor-pointer underline font-bold cl-foreground" 
                      onClick={ () => modalHandler({ "showModal": true, "mode": "wamp" }) }>
                      WAMP
                    </a>,
                  ) }
                  { renderSubSection(
                    <a className="cursor-pointer underline font-bold cl-foreground" 
                      onClick={ () => modalHandler({ "showModal": true, "mode": "intellijidea" }) }>
                      IntelliJ Idea
                    </a>,
                  ) }
                  { renderSubSection(
                    <a className="cursor-pointer underline font-bold cl-foreground" 
                      onClick={ () => modalHandler({ "showModal": true, "mode": "visualstudiocode" }) }>
                      Visual Studio Code
                    </a>,
                  ) }
                  { renderSubSection(
                    <a className="cursor-pointer underline font-bold cl-foreground" 
                      onClick={ () => modalHandler({ "showModal": true, "mode": "visualstudio" }) }>
                      Visual Studio
                    </a>,
                  ) }
                  { renderSubSection(
                    <a className="cursor-pointer underline font-bold cl-foreground" 
                      onClick={ () => modalHandler({ "showModal": true, "mode": "putty" }) }>
                      PuTTy
                    </a>,
                  ) }
                  { renderSubSection(
                    <a className="cursor-pointer underline font-bold cl-foreground" 
                      onClick={ () => modalHandler({ "showModal": true, "mode": "winscp" }) }>
                      WinSCP
                    </a>,
                  ) }
                </>
            ) }
          </div>
        );

      /**
       * Projects
       */
      case "upwn":
        return (
          <div>
            { renderSection(
              <>
                Upwn is a basic, procedurally generated side-scrolling game for Windows 
                with a variety of customisation options and goals. I developed it independently 
                as my third year project during my degree in Applied Software Engineering at Cardiff 
                University. For this project I utilised Godot due to my prior experience with the game 
                engine and its native language, GDScript. 
              </>
            ) }
            <GithubRepo
              link="https://github.com/mattdbarnett/infinite-colour-runner-game">
            </GithubRepo>
            <ProjectRow
              image1={"/pngs/upwn-splash.png"}
              image2={"/pngs/upwn-menu.png"}
              image3={"/pngs/upwn-custom.png"}
              image4={"/pngs/upwn-game.png"}>
            </ProjectRow>
          </div>
        );

      case "idwal":
        return (
          <div>
            { renderSection(
              <>
                The Idwal app is a mobile application that allows vessel surveyors working 
                in conjunction with Idwal Shipping to effectively survey ships, with the assistance 
                of AR technologies, and communicate with Idwal staff seamlessly. I developed this project 
                with a team of fellow students during the 3rd year of my undergraduate degree at 
                Cardiff University. We opted to use Flutter to develop this application.
              </>
            ) }
            <GithubRepo
              link="https://github.com/mattdbarnett/infinite-colour-runner-game">
            </GithubRepo>
            <ProjectRow
              image1={"/pngs/idwal-icon.png"}
              image2={"/pngs/idwal-home.png"}
              image3={"/pngs/idwal-survey.png"}
              image4={"/pngs/idwal-comms.png"}>
            </ProjectRow>
          </div>
        );

      case "unicalc":
        return (
          <div>
            { renderSection(
              <>
                UniCalc is a desktop application for Windows that allows students to easily calculate 
                their current university grade. I developed it independently in my free time to better 
                learn the .NET framework. 
              </>
            ) }
            <GithubRepo
              link="https://github.com/mattdbarnett/unicalc">
            </GithubRepo>
            <ProjectRow
              image1={"/pngs/unicalc-icon.png"}
              image2={"/pngs/unicalc-modules.png"}
              image3={"/pngs/unicalc-assessments.png"}
              image4={"/pngs/unicalc-results.png"}>
            </ProjectRow>
          </div>
        );

      case "robot.ai":
        return (
          <div>
            { renderSection(
              <>
                Robot.AI is a desktop application that simulates multiple robots that compete to eat 
                and reproduce. I developed it independently in my free time as I was personally interested 
                in the concept of creating a simulation and I wanted to develop a Godot application using the mono 
                variant of the engine in C# rather than using the engine's native language in order to broaden my 
                experience. 
              </>
            ) }
            <GithubRepo
              link="https://github.com/mattdbarnett/robot-ai-simulation">
            </GithubRepo>
            <ProjectRow
              image1={"/pngs/robot-icon.png"}
              image2={"/pngs/robot-home.png"}
              image3={"/pngs/robot-example1.png"}
              image4={"/pngs/robot-example2.png"}>
            </ProjectRow>
          </div>
        );

      case "activito":
        return (
          <div>
            { renderSection (
              <>
                Activito is a mobile application that allows users to log their daily activity quickly and 
                easily. I developed it independently in my free time to both improve my skills in developing 
                using Flutter and for my own personal usage.
              </>
            ) }
            <GithubRepo
              link="https://github.com/mattdbarnett/activito-app">
            </GithubRepo>
            <ProjectRow
              image1={"/pngs/activito-icon.png"}
              image2={"/pngs/activito-landing.png"}
              image3={"/pngs/activito-type.png"}
              image4={"/pngs/activito-records.png"}>
            </ProjectRow>
          </div>
        );

      default:
        return "No Body Found!";
    }
  }

}